export const DRAG_INITIATED = 'DRAG_INITIATED'
export const DRAG_SUCESSFUL = 'DRAG_SUCESSFUL'
export const DRAG_FAILED = 'DRAG_FAILED'